<template lang="html">
    <b-container>
        <div class="center-text title info-title">
            Info prodotto
        </div>
        <div class="subtitle info-subtitle">
            <strong>Partner:</strong> {{info.user.company}}
        </div>
        <div class="subtitle info-list">
                Lista ordini
        </div>
        <div>
            <div class="table table-responsive table-hover">
                <table class="w-100">
                    <thead>
                        <tr class="product-table-header">
                            <th>Richiedente</th>
                            <th>Stato</th>
                            <th>Quantità</th>
                            <th>Ordine del</th>
                        </tr>
                    </thead>
                    <tbody v-if="orders">
                        <tr v-if="orders.length<1">
                            <td colspan="100%">
                                Nessun Prodotto
                            </td>
                        <tr>
                        <tr v-for="order in orders" :key="order.id">
                            <th v-text="order.user.full_name"></th>
                            <th v-text="order.status"></th>
                            <th v-text="order.quantity"></th>
                            <th v-text="order.created_at"></th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </b-container>
</template>

<script>


export default {
  components: {
  },
  props: ['info'],
  data() {
    return {
        orders: null
    }
  },
  computed: {
  },
  created() {
    // this.refreshProductTypes()
    // this.refreshUsers()
    this.refreshProductOrders()
  },
  methods: {
    refreshProductTypes() {
      this.$http.get('product-types', { params: { only_std: true }}).then(res => {
        this.product_types = res.data
        this.is_ready = true
        this.fixProductType()
      })
    },
    refreshUsers() {
      this.$http.get('users').then(res => {
        this.users = res.data
      })
    },
    refreshProductOrders() {
      this.$http.get('product-orders', { params: {product_id: this.info.id} }).then(res => {
        this.orders = res.data
        console.log(this.orders)
      })
    }
  },

  watch: {
    // 'form.product_type_id'(){
    //   this.fixProductType()
    // },
  }
}
</script>

<style lang="css" scoped>
.info-title{
    padding: 20px 0px;
}
.info-subtitle{
    padding: 15px 0px;
}
.info-list{
    padding: 20px 0px;
    color: var(--primary);
}
</style>
